import React from "react";
import { StyledFormTitle } from "../../IntegrationWidgetSetting.styles";
import WidgetTicketType from "features/metadesk/settings/integrations/widget/components/WidgetTicketType";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { StyledWhiteContainer } from "features/metadesk/settings/common.styles";
import StepContent from "../../components/StepContent";
import useGetPagePermission from "hooks/useGetPagePermission";
import AssignTicketType from "features/metadesk/settings/Customization/AssignTicketType/AssignTicketType";
import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import Switch from "@metacrm/metacrm-material-ui/dist/Switch";

export default function IntegrationTicketType({
  widgetId,
  ticketList,
  chooseTicketType,
  setChooseTicketType,
  allowGuestTicket,
  setAllowGuestTicket,
}) {
  const pagePermission = useGetPagePermission();
  const { canEdit } = pagePermission("integration");
  const { formatMessage } = useIntl();
  const ticketBlock = {
    title: formatMessage({ id: "global.form.chooseTicketTypes" }),
    describe: formatMessage({ id: "global.form.ticketTypesDescription" }),
    content: (
      <>
        <StyledFormTitle item xs={12} md={4}>
          {formatMessage({ id: "global.header.ticketType" })}
        </StyledFormTitle>
        <Grid position={"relative"} item xs={12} md={8}>
          <AssignTicketType
            serviceName={"widget"}
            widgetId={widgetId}
            canEdit={canEdit}
            ticketList={ticketList}
            chooseTicketType={chooseTicketType}
            setChooseTicketType={setChooseTicketType}
          />
        </Grid>
        <Box
          sx={{
            height: "1px",
            width: "100%",
            background: "#E6E6E6",
            marginTop: "16px",
            marginBottom: "16px",
          }}
        ></Box>
        <Grid position={"relative"} item xs={12}>
          <Box>
            <Box color={(theme) => theme.customColors.grey[700]} mb={1}>
              {formatMessage({
                id: "widgetSettings.ticketSubmissionControl.title",
              })}
            </Box>
            <Box
              color={(theme) => theme.customColors.grey[600]}
              sx={{ fontSize: "14px" }}
              mb={2}
            >
              {formatMessage({
                id: "widgetSettings.ticketSubmissionControl.description",
              })}
            </Box>
            <Box color={(theme) => theme.customColors.grey[700]} mb="14px">
              {formatMessage({
                id: "widgetSettings.ticketSubmissionControl.switch",
              })}
            </Box>
            <Box>
              <Switch
                iosSwitch
                checked={allowGuestTicket}
                onChange={setAllowGuestTicket}
              ></Switch>
            </Box>
          </Box>
        </Grid>
      </>
    ),
    noBottomPadding: true,
  };
  return (
    <StyledWhiteContainer style={{ marginBottom: "12px" }}>
      <StepContent settingStep={ticketBlock} />
    </StyledWhiteContainer>
  );
}
